const colors = {
  green: '#1ab394',
  lightGreen: '#d6f2ef',
  darkGreen: '#148f76',
  grey: '#e7eaec',
  darkGrey: '#757575',
  brown: '#383333',
  trans: 'transparent',
  blue: '#3f51b5',
  red: '#E85030',
  primary: '#3E8FFA',
  secondary: '#34bfff',
  tertiary: '#F1800D',
  lightSecondary: '#cff0ff',
  yellow: '#F5D409',
};

export default colors;
